<template>
  <div class="login">
    <div class="container">
      <div class="signUp">
        <div class="logo">
          <p class="graviaguas"><span>G</span>RAVI ÁGUAS</p>
          <h6>Distribuidora de produtos para Auto Vidros</h6>
          <p>Entre em contato para ter acesso a nossos produtos e sistemas de gravação.</p>
          <p class="phone">(49) 3339-0000 / <span><a href="https://api.whatsapp.com/send?phone=5549984221101&text=Ol%C3%A1%2C%20gostaria%20de%20tirar%20uma%20d%C3%BAvida.%20Poderiam%20me%20ajudar%3F" target="_blank">(49) 98422-1101</a></span></p>
        </div>
        <div class="form">
          <form @submit.prevent="doLogin()">
            <div class="form-group">
              <label for="inputEmail" class="mb-n2">Email</label>
              <input
                type="email"
                id="inputEmail"
                v-model="email"
                class="form-control"
                placeholder="Informe o Email"
              >
            </div>
            <div class="form-group mb-4 mt-n2 password-group">
              <label for="inputPassword" class="mb-n2">Senha</label>
              <input
                :type="showPassword ? 'text' : 'password'"
                id="inputPassword"
                v-model="password"
                class="form-control"
                placeholder="Informe a Senha"
              >
              <i
                :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                class="password-toggle"
                @click="showPassword = !showPassword"
              ></i>
            </div>
            <button class="btn btn-primary">Acessar</button>
            <span><a href="https://api.whatsapp.com/send?phone=554933390000&text=Olá, gostaria de solicitar acesso ao sistema de gravação de chassi (gravacaochassi.com)" target="_blank">Solicitar Acesso</a></span>
            <div class="forgot">
              <a @click.prevent="forgotPassword()" href="#">Esqueci minha senha</a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <a href="https://www.lucianoramos.dev/" class="lucianoRamos" target="_blank" rel="noopener noreferrer">Desenvolvido por Luciano Ramos</a>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    email: '',
    password: '',
    users: [],
    register: false,
    showPassword: false
  }),
  methods: {
    async doLogin () {
      const { email, password } = this

      if (this.validation()) {
        this.loading = true

        try {
          this.$root.$emit('Spinner::show')
          const resp = await this.$firebase.auth().signInWithEmailAndPassword(email, password)

          window.uid = resp.user.uid

          this.userCurrent()

          this.$router.push({ name: 'productsList' })
        } catch (error) {
          let message = ''

          switch (error.code) {
            case 'auth/user-not-found':
              message = 'Não foi possivel localizar o usuário.'
              break
            case 'auth/wrong-password':
              message = 'Senha inválida.'
              break
            default:
              message = 'Não foi possível fazer o login, tente novamente.'
          }

          this.$root.$emit('Notification::show', {
            message,
            type: 'danger'
          })
        }
        this.loading = false
      }
      this.$root.$emit('Spinner::hide')
    },
    userCurrent () {
      this.$firebase.database().ref(`users/${window.uid}`)
        .on('value', (data) => {
          const userCurrent = data.val()

          if (userCurrent) {
            if (userCurrent.admin) {
              this.$root.$emit('Admin::show')
            } else {
              this.$root.$emit('Admin::hide')
            }
          } else {
            // Se não encontrar o usuario na base ele vai ter a conta eliminada.
            this.$firebase.auth().currentUser.delete()
          }
        })
    },
    async forgotPassword () {
      if (!this.email) {
        this.$root.$emit('Notification::show', {
          message: 'Informe o email para redefinir a senha.',
          type: 'warning'
        })
        return
      }
      try {
        this.$root.$emit('Spinner::show')
        await this.$firebase.auth().sendPasswordResetEmail(this.email)
        this.$root.$emit('Notification::show', {
          message: 'Email de redefinição enviado. Verifique sua caixa de entrada.',
          type: 'success'
        })
      } catch {
        this.$root.$emit('Notification::show', {
          message: 'Não foi possível enviar o email. Verifique o endereço informado.',
          type: 'danger'
        })
      } finally {
        this.$root.$emit('Spinner::hide')
      }
    },
    validation () {
      if (!this.email) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar o email.',
          type: 'warning'
        })
      } else if (!this.password) {
        this.$root.$emit('Notification::show', {
          message: 'Favor informar a senha.',
          type: 'warning'
        })
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(53,144,187,1) 0%, rgba(60,130,208,1) 90% );
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  .container {
    width: 360px;
    height: 630px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 5px 5px 8px 0px rgba(0, 0, 0, 0.5);
    .signUp {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 30px;
      color: #696969;
      .logo {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .graviaguas {
          font-family: 'Poppins', sans-serif;
          font-size: 32px;
          color: #1b9bff;
          font-weight: 400;
          letter-spacing: 1px;
          margin-bottom: 8px;
          span {
            background-color: #1b9bff;
            border-radius: 5px;
            color: #e7e7e7;
            font-size: 46px;
            margin-right: 5px;
            padding: 0px 18px;
          }
        }
        .phone {
          font-weight: 500;
          margin-top: -15px;
        }
      }
      .form {
        width: 100%;
        height: 70%;
        padding: 0 30px;
        button {
          padding: 7px 25px;
        }
        span {
          margin-left: 20px;
          color: #028af1;
          &:hover {
            cursor: pointer;
          }
        }
        .password-group {
          position: relative;
          .password-toggle {
            position: absolute;
            right: 10px;
            top: 34px;
            cursor: pointer;
            color: #696969;
            &:hover {
              color: #028af1;
            }
          }
        }
        .forgot {
          margin-top: 10px;
          a {
            font-size: 13px;
            color: #028af1;
            &:hover {
              color: #1b9bff;
            }
          }
        }
      }
    }
    .register {
      width: 100%;
      height: 100%;
      padding: 40px 40px;
      h4 {
        color: #696969;
        margin-bottom: 12px;
      }
      button {
        padding: 7px 25px;
      }
    }
  }
  .lucianoRamos {
    position: absolute;
    bottom: 10px;
    right: 20px;
    color: #e7e7e7;
    font-size: 12px;
      &:hover {
      cursor: pointer;
      color: #d1d1d1;
    }
  }
}

@media (min-width: 780px) {
  .login {
    .container {
      width: 750px;
      height: 400px;
      .signUp {
        flex-direction: row;
        padding-top: 0;
        .logo {
          width: 50%;
          height: 100%;
          padding: 0 20px;
        }
        .form {
          width: 50%;
          height: 100%;
          padding-top: 90px;
        }
        .register {
          width: 50%;
          height: 100%;
          padding-top: 60px;
        }
      }
    }
  }

}
</style>
